import React from "react";
import styled from "styled-components";
import LabelText from "../../ui/LabelText";
import InfoIcon from "../../assets/icons/infoicon.svg";

interface HeaderTextWithIconProps {
  text: string;
  isIcon?: boolean;
  isFromOverview?: boolean;
}

const HeaderTextWithIcon: React.FC<HeaderTextWithIconProps> = ({
  text,
  isIcon = true,
  isFromOverview = false,
}) => {
  return (
    <Container isFromOverview={isFromOverview}>
      <LabelText className="header-text">{text}</LabelText>
      {isIcon && <img src={InfoIcon} />}
    </Container>
  );
};

// Add props interface for styled component
const Container = styled.div<{ isFromOverview: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${({ isFromOverview }) => (isFromOverview ? "0px 0px 14px 0px" : "14px 0px")};
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

export default HeaderTextWithIcon;
